import { Component } from '@angular/core';
//import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
//

@Component({
  selector: 'app-root',
  providers: [Location],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Szych Consulting';
  location: Location;
  /*public modalRef: BsModalRef; // {1}*/
  constructor(location: Location, _router: Router) {
    this.location = location; 
  } // {2}

  /*public openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template); // {3}
  }*/
  
  public isHidden() {
  let list = ["/home", ""],
      route = this.location.path();

    return (list.indexOf(route) == -1);
  }
}



// WEBPACK FOOTER //
// /Users/globant/site/src/app/app.component.ts